import React from "react";
import TabList from "./TabList";

/**
 * EditorTabs component - Tab bar for open files
 * @param {Object} props - Component props
 * @param {Array} props.openTabs - Array of open tab objects
 * @param {Object} props.activeTab - Currently active tab
 * @param {Set} props.modifiedFiles - Set of modified file paths
 * @param {Function} props.onTabSwitch - Handler for switching tabs
 * @param {Function} props.onTabClose - Handler for closing tabs
 * @returns {JSX.Element} The editor tabs bar
 */
const EditorTabs = ({
  openTabs,
  activeTab,
  modifiedFiles,
  onTabSwitch,
  onTabClose,
}) => {
  return (
    <div className="bg-gray-50 dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-700 flex overflow-x-auto tabs-scrollbar h-[53px]">
      <TabList
        tabs={openTabs}
        activeTab={activeTab}
        modifiedFiles={modifiedFiles}
        onTabClick={onTabSwitch}
        onTabClose={onTabClose}
      />
    </div>
  );
};

export default EditorTabs;
